export default __webpack_public_path__ + "static/media/telegram.6f0d4136.svg";